<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="noindent_t_1"><b><i>A classic Amish tale of second chances previously titled </i>The Inn at Hope Springs<i> from bestselling author Patricia Davids (2010)</i></b></p>
<p class="noindent_t1">Emma Wadler has made a good life for herself, running the Wadler Inn in the town of Hope Springs, Ohio. She has accepted her life as an “old maid,” and is content catering to the tourists who come to view her Amish community. She had once hoped to marry and raise a family of her own, but her fiancé died tragically when they were both only seventeen, and Emma has guarded her heart ever since.</p>
<p class="noindent_t1">Adam Troyer fixes things. Having just returned to the faith after years in the English world, Adam is hoping to prove to his father that he is committed to a simple life. So he’s happy to be hired by Emma’s mother to make repairs to the inn during the winter off-season. The old Swiss-style Chalet has its share of problems, but nothing he can’t fix. Nothing except perhaps the broken heart of the owner….</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369704351_BCC.vue?6af96476